import { GoogleApiWrapper, Map, Marker } from 'google-maps-react';
import { useEffect } from 'react';
import { fromLatLng, setKey, setLanguage } from 'react-geocode';
import makerIcon from '../../assets/markerIcon.svg';
function MapAddress({ setMapInfo, setNewLatLng, newLatLng, google, isEdit,name,form }) {
  useEffect(() => {
    setKey('AIzaSyCW0YeXO7ivoy_5RJ-M6svq2WHvaL_Zawc');
    setLanguage('en');
  }, []);

  const onMapClicked = (c, m, e) => {

    let lat = e?.latLng?.lat();
    let lng = e?.latLng?.lng();
    setNewLatLng({
      lat,
      lng,
    });
    handelGeocode(lat, lng);
  };
 const GetNamesLocation = (data) => {
    data?.map((e) => {
      switch (e.types[0]) {
        case "administrative_area_level_1":
          form.setFieldsValue({
            [name]: { City: e.long_name, main: e.long_name },
          });
          break;
        case "administrative_area_level_2":
          form.setFieldsValue({
            [name]: { District: e.long_name },
          });
          break;
        
        case "country":
          form.setFieldsValue({
            [name]: { Country: e.long_name },
          });
          break;
        default:
          // Handle any other types or do nothing for unhandled types
          break;
      }
    });
  };
  const handelGeocode = (lat, lng) => {
    fromLatLng(lat, lng).then(
      (response) => {
        console.log(response?.results);
        GetNamesLocation(response?.results[0].address_components);
        const address = response?.results[0]?.formatted_address;
        console.log(address);
        setMapInfo(response?.results[0]?.formatted_address);
      },
      (error) => {
        console.error(error, 'errrrrrrrr');
      }
    );
  };
  return (
    <div
      className="relative map-holder"
      style={{ height: '25vh', width: '100%' }}
    >
      {newLatLng?.lat && newLatLng?.lng && (
        <Map
          google={google}
          streetViewControl={false}
          zoomControl={true}
          initialCenter={{ lat: newLatLng?.lat, lng: newLatLng?.lng }}
          mapTypeControl={false}
          fullscreenControl={true}
          zoom={15}
          center={{ lat: newLatLng?.lat, lng: newLatLng?.lng }}
          onClick={isEdit && onMapClicked}
        >
          <Marker
            icon={{
              url: makerIcon,
            }}
            position={{ lat: newLatLng?.lat, lng: newLatLng?.lng }}
          />
        </Map>
      )}
    </div>
  );
}

export default GoogleApiWrapper({
  apiKey: 'AIzaSyCW0YeXO7ivoy_5RJ-M6svq2WHvaL_Zawc',
  libraries: ['places'],
})(MapAddress);
